<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando"> 
                <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false" @tableatualizada="tableatualizada( $event )" > 
                    <th style="max-width:100px">Id</th>
                    <th>Nome</th> 
                    <th>Inicio</th> 
                    <th>Fim</th> 
                    <th>Atualizado em</th> 
                    <th>Status</th> 
                    <th style="min-width:190px" class="text-center" v-if="hasPermissao">Arquivo</th> 
                    <th style="min-width:190px" class="text-center" v-if="hasPermissao">Ações</th> 
                    <template v-slot:filtros>   
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                            <div class="mb-2">
                                <label for="DataMin" class="form-label">Data</label>
                                <input  @keyup="apertouEnter" @blur="refreshTable"  type="date" data-kt-docs-table-filter="Data" class="form-control form-control-solid " placeholder="Data"/>
                            </div>
                        </div> 
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2" v-if="status">
                            <div class="mb-2"> 
                                <label  for="StatusAula" class="form-label">Status:</label>  
                                <Multiselect @change="refreshTable" :options="status_select" :searchable="true"  v-model="status_id" ></Multiselect>    
                            </div> 
                        </div> 
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-7">
                            <div class="card-header border-0" v-if="hasPermissaoAdmin || ( hasPermissao && turma && turma.status.id == 1 )">
                                <h6 class="card-title align-items-start flex-column"> </h6>
                                <div class="card-toolbar m-0">
                                    <button type="button" class="btn btn-sm btn-pmes-primary" title="Cadastrar"  data-bs-toggle="modal" :data-bs-target="'#'+modal_cadastro"> 
                                        <span class="menu-icon">
                                            <i class="fa fa-plus fa-2x bi"></i> 
                                        </span>
                                        Cadastrar Qts
                                    </button>  
                                    <Cadastro :service="service" @qts-alterado="refreshTable" :modal="modal_cadastro" :perfis="perfis"/>   
                                    <Editar @update-qts-alterado="modeloAlterado" :service="service" :modelo="dados" :modal="modal_atualizar" v-if="hasPermissao" :perfis="perfis"/> 

                                    <Arquivo @qts-alterado-arquivo="modeloAlterado"  :modelo="dados" :modal="modal_arquivo" v-if="hasPermissao" :perfis="perfis"/> 

                                </div>
                            </div> 
                        </div> 
                        <input type="text" data-kt-docs-table-filter="turmaId" v-model="turmaId" hidden/>  
                        <input type="text" data-kt-docs-table-filter="Status" v-model="status_id" hidden/>
                    </template>
                </KDataTable>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts"> 
    import { Options, Vue } from "vue-class-component";
    import { namespace } from 'vuex-class';
    const authStore = namespace('auth'); 
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue"   
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import QtsPdfService from '@/service/v1/sigap/QtsPdfService';
    import  Cadastro from   "./_Cadastro.vue"   
    import {  Prop , Watch  } from 'vue-property-decorator';   
	import $ from "jquery"   
    import Editar from   "./_Editar.vue"   
    import Arquivo from   "./_EditarArquivo.vue"   
    import Multiselect from '@vueform/multiselect'

    @Options({
        name: "QtsPdf",
        components: {  CardRh , KDataTable, Cadastro , Editar , Arquivo, Multiselect},
    }) 
    export default class QtsPdf extends Vue {
          
        @Prop( ) readonly turma!: any

        @authStore.Getter
        public perfis!: any
          
        public status_id: any = null;
        public status: any = null;
        public turmaId: any = null;
        public dados: any = null;
        public modal_atualizar = 'modal_visualizar_qts_update_';   
        public modal_cadastro = 'kt_cadatrar_turma_qts_';
        public modal_arquivo = 'kt_cadatrar_turma_qts_atualizar_arquivo';
        public processando = false; 
        public reloadDatatable = false ;
        public config: any = null;  
        public service: any = new QtsPdfService();    
  
        
        get hasPermissaoAdmin( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin   ] ,  this.perfis);
        }

        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
         
        public refreshTable(){ 
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable ; 
            }, 300); 
        }
         
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                this.refreshTable();
            }
        }
 
        public modeloAlterado(newVal: string) { 
			this.reloadDatatable = !this.reloadDatatable; 
			this.dados = null ; 
		} 
         
        
        get status_select(){
            if(this.status){
                return this.status.map((item) => { return { value:  item.id , label: item.nome } });   
            }
            return null;
        }
        
        public getStatus(){   
            this.processando = true ; 
            this.service.getStatus(    ) 
            .then(response => {   
                this.status =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        created(){   
            this.getStatus(); 
            this.turmaId = this.$route.params.id;  
            this.config = {  ajax: {} , columns: [] , columnDefs: [] , order: [] };  
            this.config.ajax = { 
                url: this.service.getApiUrl()  ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length,  
                        "turmaId": () => (document.querySelector('[data-kt-docs-table-filter="turmaId"]')! as HTMLInputElement).value ,  
                        "status": () => (document.querySelector('[data-kt-docs-table-filter="Status"]')! as HTMLInputElement).value , 
                        "data": () => (document.querySelector('[data-kt-docs-table-filter="Data"]')! as HTMLInputElement).value ,  
                        "search": d.search.value
                    }
                    return dados; 
                } 
            }; 
            this.config.order = [[2, 'desc']];
            this.config.columns = [  
                { data: "id", name: "id" }, 
                { data: "nome", name: "nome" },   
                { data: "inicio", name: "inicio" },   
                { data: "fim", name: "fim" },   
                { data: "updatedAt", name: "updatedAt" },   
                { data: "status.nome", name: "status" },   
            ];
            
            this.config.columnDefs = [ 
                {
                    targets: 2,
                    render: function ( row, type, val, meta ) {  
                        return SiteUtils.formatData( row )  ;
                    }
                }, 
                {
                    targets: 3,
                    render: function ( row, type, val, meta ) {  
                        return SiteUtils.formatData( row )  ;
                    }
                }, 
                {
                    targets: 4,
                    render: function ( row, type, val, meta ) {  
                        return SiteUtils.formatDataHora( row )  ;
                    }
                }, 
            ]; 
            if(this.hasPermissao){
                this.pushColunaAcoes()
                this.pushColunaAcoes()
                this.config.columnDefs.push( 
                    {
                        targets: 6,
                        render: ( row, type, val, meta ) => {  
                            let texto = '' ; 
                            let buttom = '' ;  
                            for (var key in val) {  buttom = buttom + ' data-' + key + '="'+ val[key] +'"'  }    
                            texto = texto + '<button class="btn btn-success btn-sm" btn-editar-arquivo '+ buttom +'   data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_arquivo  + '" title="Editar"><i class="fa fa-file-arrow-up"></i></button>';   
                            return texto;  
                        }, 
                    }, 
                    {
                        targets: 7,
                        render: ( row, type, val, meta ) => {  
                            let texto = '' ; 
                            let buttom = '' ;  
                            for (var key in val) {  buttom = buttom + ' data-' + key + '="'+ val[key] +'"'  }    
                            texto = texto + '<button class="btn btn-success btn-sm" btn-editar '+ buttom +'   data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_atualizar  + '" title="Editar"><i class="fa fa-edit"></i></button>';   
                            texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-link '+ buttom +' title="Link"><i class="fa fa-link"></i></button>';   
                            texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir-qts ' + buttom + ' ><i class="fa fa-trash"></i> </button>';   
                            texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-notificar-qts ' + buttom + ' ><i class="fa fa-paper-plane"></i> </button>';   
                            return texto;  
                        }, 
                    },  
                );   
            }

           
        
        }     

        
        pushColunaAcoes(){ 
            this.config.columns.push({ data: 'id', name: 'id'  , orderable: false, searchable: false , class: 'text-center' });
        }  

        public tableatualizada( event ) {  
            $('[btn-link]').click(  (btn) => {   
                let id =   $(btn.currentTarget).data('id');   
                this.getModelLink(id );  
            });  

            $('[btn-editar]').click(  (btn) => {   
                this.dados =   null; 
                setTimeout(() => {
                    this.dados =   $(btn.currentTarget).data( );  
                }, 10); 
            }); 


            $('[btn-editar-arquivo]').click(  (btn) => {   
                this.dados =   null; 
                setTimeout(() => {
                    this.dados =   $(btn.currentTarget).data( );  
                }, 10); 
            }); 


            $('[btn-excluir-qts]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id');  
                this.excluirModelo(id); 
            }); 

            $('[btn-notificar-qts]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id');  
                this.notificar(id); 
            }); 
        } 
        

        
        protected notificar( id  ) {  
           this.processando = true;  
            setTimeout(() => {
                this.service.notificar( id )
                .then(response => {    
                    this.processando = false; 
                })
                .catch(error => { 
                    this.processando = false;  
                });  
            }, 1); 
        }  


        protected getModelLink( id  ) {  
           this.processando = true;  
            setTimeout(() => {
                this.service.getModelLink( id )
                .then(response => {    
                    this.processando = false;
                    window.open(response, "_blank" ) 
                })
                .catch(error => { 
                    this.processando = false;  
                });  
            }, 1); 
        }  

        
        protected excluirModelo( id  ) {  
            SiteUtils.alertConfimacao('Confirma a Exclusão ','' , 
                () => {  
                    this.processando = true;  
                    setTimeout(() => {
                            this.service.excluir( id )
                        .then(response => {     
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Exclusao realizada com sucesso!!' ); 
                            this.processando = false;
                        })
                        .catch(error => { 
                            this.processando = false; 
                            SiteUtils.toastErro('Não foi possivel Excluir ' , error.data.message); 
                        });  
                    }, 10); 
                }
            );  
        }  
    } 
  
</script>